export default "__VITE_PUBLIC_ASSET__101d0f02__"